import { Inject, Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ROWITEM } from 'src/app/app.module';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNConsultation, CNConsultationType } from 'src/app/models/cnconsultation';
import * as moment from 'moment';

@ManageType('ContactRowComponent')
@Component({
  selector: 'app-contact-row',
  templateUrl: './contact-row.component.html',
  styleUrls: ['./contact-row.component.scss']
})
export class ContactRowComponent implements OnInit {

  @Input() item: CNConsultation;
  public type: CNConsultationType;

  constructor(@Inject(ROWITEM) private injectedItem: CNConsultation) { }

  ngOnInit(): void {
    this.item = this.item || this.injectedItem;
    if (this.item) {
      if (this.item.getProperty('StVaast_Type')) {
        this.type = this.item.getProperty('StVaast_Type');
      } else {
        this.type = CNConsultationType.Simple;
      }
    }
  }

  getUser() {
    return this.item.healthagent ? this.item.healthagent.lastname + ' ' + this.item.healthagent.firstname : '';
  }

  getDate() {
    return moment(this.item.date).format('DD/MM/YYYY');
  }
}
